import type React from 'react';

import {
  SnackbarProvider as NotistackProvider,
  closeSnackbar,
} from 'notistack';
import IconButton from '@mui/material/IconButton';
import { Iconify } from '@mfw/components';
import { useRef } from 'react';

import { ChatMessageToast } from '../../components/ChatMessageToast/ChatMessageToast';
import { NotificationToast } from '../../components/NotificationToast/NotificationToast';
import './SnackbarProvider.scss';

export type SnackbarProviderProps = {
  children: React.ReactNode;
};

const ANCHOR_ORIGIN = { horizontal: 'right', vertical: 'bottom' } as any;

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  // TODO Add RTL support

  const notistackRef = useRef<any>(null);

  return (
    <NotistackProvider
      // The icons are INK on the snackbar's paper surface (`bg-background-paper`
      // in the stylesheet), so they take the on-surface step: the status colour's
      // `main` is a fill and reads 1.7–3:1 here on a light tenant.
      iconVariant={{
        error: (
          <Iconify
            className="mr-2 text-error-onSurface"
            icon="solar:danger-bold"
            size="medium"
          />
        ),
        info: (
          <Iconify
            className="mr-2 text-info-onSurface"
            icon="eva:info-fill"
            size="medium"
          />
        ),
        success: (
          <Iconify
            icon="eva:checkmark-circle-2-fill"
            className="mr-2 text-success-onSurface"
            size="medium"
          />
        ),
        warning: (
          <Iconify
            className="mr-2 text-warning-onSurface"
            icon="eva:alert-triangle-fill"
            size="medium"
          />
        ),
      }}
      // with close as default
      action={(snackbarId) => (
        <IconButton
          onClick={() => closeSnackbar(snackbarId)}
          className="p-1"
          size="small"
        >
          <Iconify
            className="text-text-primary"
            icon="mingcute:close-line"
            size="small"
          />
        </IconButton>
      )}
      Components={{
        chatMessage: ChatMessageToast,
        notification: NotificationToast,
      }}
      anchorOrigin={ANCHOR_ORIGIN}
      // TODO Add RTL support
      // TransitionComponent={isRTL ? Collapse : undefined}
      autoHideDuration={3000}
      ref={notistackRef}
      variant="success"
      preventDuplicate
      maxSnack={5}
    >
      {children}
    </NotistackProvider>
  );
};
